import { lazy, Suspense, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "@/components/breadcrumbs";

const DbtDocsDetails = lazy(() => import("../../components/dbtDocs/details/DbtDocsDetails"));

const DbtDocsDetailsPage = () => {
  const { shareId } = useParams();
  useBreadcrumb(shareId ?? "Details", {
    defaultParents: [{ label: "dbt Docs", pathname: "/collaboration/dbt-docs" }],
  });
  useEffect(() => {
    return () => {
      // Hack to reset the injected styles not to affect existing UI
      // dbt docs component injects styles into head tag
      // this affects the UI ofexising element and break the interactions
      // reload the window after navigating away from this page, to reset the styles
      setTimeout(() => {
        document.location.reload();
      }, 100);
    };
  }, []);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <DbtDocsDetails />
    </Suspense>
  );
};

export default DbtDocsDetailsPage;
